'use strict';

(function ($, Drupal, once) {
  Drupal.behaviors.articleListingFilters = {
    attach: function (context) {
      $(once('articleListingFilters', '.filter-wrapper', context)).each(function () {
        var $form = $(this).find('.views-exposed-form');
        $(this).find('.filter-toggler')
          .on('click', function () {
            var $button = $(this);
            if ($button.attr('aria-expanded') === 'false') {
              $button.attr('aria-expanded', 'true');
              $('span', $button).text('Close Filter');
              $form.attr('aria-hidden', 'false').show();
            }
            else {
              $button.attr('aria-expanded', 'false');
              $('span', $button).text('Filter Content');
              $form.attr('aria-hidden', 'true').hide();
            }
            return false;
          });

        $form.each(function () {
          var $form = $(this);
          var gtm_data = {};

          $('.form-item-search input[type="text"]', $form).on('focus', function () {
            $(this).parent().addClass('focused');
          }).on('blur', function () {
            $(this).parent().removeClass('focused');
          });
          // Push form values into the GTM data layer.
          if (Object.keys(gtm_data).length) {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push(gtm_data);

          }
        }).submit(function () {
          var $form = $(this);

          var $topics = $form.find('#edit-tags input:checked').map(function () {
            return this.value;
          }).get();

          var $program = $form.find('#edit-program input:checked').map(function () {
            return this.value;
          }).get();

          var $audience = $form.find('#edit-audience input:checked').map(function () {
            return this.value;
          }).get();

          dataLayer.push({
            'formLocation': 'news-events',
            'event': 'search',
            'category': 'Engagement',
            'label': 'Newsroom Filter',
            'action': 'text: ' + $form.find('#edit-search').val() + ' topic: ' + $topics + ' program: ' + $program + ' audience: ' + $audience
          });
        });
      });
    }
  }
})(jQuery, Drupal, once);
